export default "__VITE_ASSET__9d512209__"